import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

export const ServiceTypeFilterContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 300px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FilterLabel = styled(Typography)`
  && {
    font-family: inherit;
    font-weight: 600;
    color: #1a1a2e;
    font-size: 0.9rem;
    line-height: 1.3;
  }
`;

export const ServiceTypeFilter = styled(Box)`
  width: 100%;
`;
